import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useSelector } from 'react-redux';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { IDispute } from '../../utils/types';
import { selectCurrentUser, selectCurrentEmpid } from '../../pages/login/authSlice';
import '../../features/disputes/dispute.scss';
import {
    useGetDisputeReasonsQuery,
    useGetResolutionReasonsQuery,
    useResolveDisputeMutation,
    useResolveAllDisputesMutation,
} from '../../features/disputes/disputeSlice';
import { recalculateAssociate } from '../recalculateAssociate/recalculateAssociate';
import DescriptionBox from '../descriptionBox/DescriptionBox';

export const ResolveAgentDispute = (props: any) => {
    const [ResolveDispute] = useResolveDisputeMutation();
    const [ResolveAllDisputes] = useResolveAllDisputesMutation();
    const [disputeDialog, setDisputeDialog] = useState(false);
    const loggedUser = useSelector(selectCurrentUser);
    const [formFields, setFormFields] = useState<any>([]);
    const loggedUserId = useSelector(selectCurrentEmpid);
    const [saveSuccessMessage, setSaveSuccessMessage] = useState('');
    const [enableSave, setEnableSave] = useState(false);
    const [resolveAllClicked, setResolveAllClicked] = useState(false);
    const [inputResolutionReasonId, setInputResolutionReasonId] = useState(0);
    const [inputResolutionComment, setInputResolutionComment] = useState('');
    const [resolveDisputesData, setResolveDisputesData] = useState<any>([]);
    const { data: disputeReasonData } = useGetDisputeReasonsQuery({
        typeId: 1,
    });
    const { data: resolutionReasons } = useGetResolutionReasonsQuery({ typeId: 2 });
    useEffect(() => {
        if (props?.selectedRowDisputeDetails?.agentDailyDisputes !== undefined) {
            setDisputeDialog(props.disputeDialogEnable);
            const color = ['Blue ', 'Green', 'Orange', 'Violet', 'Indigo'];
            const metricDetails = props?.selectedRowDisputeDetails;
            const disputedMetrics =
                metricDetails !== undefined
                    ? Object.values(props?.selectedRowDisputeDetails?.agentDailyDisputes[0]?.disputeDetails)
                    : [];
            let index = 0;
            const disputes: IDispute[] = [];
            disputedMetrics.forEach((item: any) => {
                if (item.dispute_status_id === 1) {
                    index++;
                    const dispute: IDispute = {
                        empDailyResultId: props.selectedRowDisputeDetails.emp_daily_result_id,
                        metricName: item.metric_name,
                        metricLabel: item.metric_label,
                        disputedValue: item.disputed_value ? item.disputed_value.toString() : undefined,
                        disputeReasonid: item.dispute_reason_id,
                        proposedValue: item.proposed_value ? item.proposed_value.toString() : undefined,
                        disputeComment: item.dispute_comment,
                        disputeId: item.dispute_id,
                        employeeNumber: metricDetails.agent_number,
                        disputeCreateBy: props.selectedRowDisputeDetails.disputeCreateBy,
                        metricId: item.metric_id,
                        disputeDate: item.dispute_create_date,
                        metricHeaderColor: color[index],
                        resolutionReasonId: 0,
                        resolutionComment: '',
                        resolutionClicked: false,
                        disputeStatusId: 2,
                        disputeTypeId: 1,
                        resolvedBy: loggedUserId,
                    };
                    disputes.push(dispute);
                }
                setFormFields(disputes);
            });
        }
    }, [props.selectedRowDisputeDetails]);

    const handleFormChange = (event: any, index: number) => {
        const data = [...formFields];
        data[index][event.target.name] = event.target.value;
        setFormFields(data);
        let isFormValid = true;
        const dispute: IDispute = data[index];
        if (
            dispute.resolutionClicked === true &&
            (dispute.resolutionReasonId === 0 || dispute.resolutionComment.trim() === '')
        ) {
            setEnableSave(false);
            isFormValid = false;
        }
        if (isFormValid === true) {
            setEnableSave(true);
        }
        return true;
    };

    const saveMetricDisputeClicked = () => {
        if (!resolveAllClicked) {
            const disputeList: IDispute[] = [];
            formFields.forEach((item: any) => {
                if (item.resolutionClicked === true) {
                    disputeList.push(item);
                }
            });
            resolveMetricDispute(disputeList);
        } else {
            resolveDisputesData.resolutionReasonId = inputResolutionReasonId;
            resolveDisputesData.resolutionComment = inputResolutionComment;
            resolveDisputesData.resolvedBy = loggedUserId;
            resolveDisputesData.disputeStatusId = 2;
            resolveDisputesData.disputeTypeId = 1;
            ResolveAllDisputes(resolveDisputesData)
            .unwrap()
            .then(() => {
                setResolveAllClicked(false);
                setSaveSuccessMessage('Dispute Resolved Successfully');
                window.localStorage.unCheckBox = true;

                resolveDisputesData.employeenumber.forEach((employeeNumber: number) => {
                    recalculateAssociate(
                        employeeNumber.toString(),
                        resolveDisputesData.scorecardVersionId,
                        resolveDisputesData.year,
                        resolveDisputesData.month,
                        loggedUserId
                    );
                });
            })
            .then((error: any) => {
                console.log(error);
            });
        }
    };
    const resolveMetricDispute = (disputes: any) => {
        const data = {
            disputes,
        };
        ResolveDispute(data)
        .unwrap()
        .then(() => {
            setSaveSuccessMessage('Dispute Resolved Successfully');
            recalculateAssociate(
                props.agentNumber,
                props.scorecardVersion,
                props.inputyear,
                props.inputmonth,
                loggedUserId
            );
        })
        .then((error: any) => {
            console.log(error);
        });
    };
    const disputeModalHeader = () => {
        return (
            <h5 className="pe-3">
                <span style={{ fontSize: '16px', fontWeight: 700 }} className="pt-2">
                    Resolve Dispute
                </span>
            </h5>
        );
    };

    const disputeModalFooter = () => {
        return (
            <React.Fragment>
                <Divider />
                <Button
                    className="btn-primary w-auto float-end"
                    onClick={saveMetricDisputeClicked}
                    hidden={saveSuccessMessage !== ''}
                    disabled={!enableSave}
                >
                    Save Changes
                </Button>
                <Button
                    className="btn-secondary w-auto float-end"
                    onClick={hideDisputeDialog}
                >
                    Cancel
                </Button>
            </React.Fragment>
        );
    };

    const dialogFuncMap = {
        disputeDialog: setDisputeDialog,
    };

    const hideDisputeDialog = () => {
        dialogFuncMap.disputeDialog(false);
        if (props.closeResolveDisputes !== undefined) {
            props.closeResolveDisputes(false);
        }
        if (props.setResolveAllClicked !== undefined) {
            props.setResolveAllClicked(false);
        }
        const data = [...formFields];
        data.forEach((item: any, index: any) => {
            data[index].resolutionClicked = false;
            data[index].resolutionComment = '';
            data[index].resolutionReasonId = 0;
        });
        setFormFields(data);
        setSaveSuccessMessage('');
        setInputResolutionComment('');
        setInputResolutionReasonId(0);
        setResolveAllClicked(false);
    };
    useEffect(() => {
        setDisputeDialog(props.disputeDialogEnable);
        setResolveAllClicked(props.resolveAllClicked);
        setResolveDisputesData(props.data);
    }, [props]);
    const ResolveDisputeClick = (index: any) => {
        const data = [...formFields];
        data[index].resolutionClicked = true;
        setFormFields(data);
        setEnableSave(false);
    };
    const handleResolveFormChange = (event: any) => {
        if (event.target.name === 'resolutionComment') {
            setInputResolutionComment(event.target.value);
        } else {
            setInputResolutionReasonId(event.target.value);
        }
    };
    useEffect(() => {
        if (inputResolutionComment.trim() !== '' && inputResolutionReasonId !== 0) {
            setEnableSave(true);
        } else {
            setEnableSave(false);
        }
    }, [inputResolutionComment, inputResolutionReasonId]);
    return (
        <div>
            <Dialog
                visible={disputeDialog}
                style={{ width: '50vw' }}
                header={disputeModalHeader}
                modal
                className="p-fluid disputeModal"
                onHide={hideDisputeDialog}
                footer={disputeModalFooter}
            >
                {saveSuccessMessage === '' ? (
                    <div className="row">
                        {!resolveAllClicked ? (
                            formFields.map((form: any, index: number) => {
                                return (
                                    <React.Fragment key={index}>
                                        <Divider className="m-0 pb-4" />
                                        <div className="col-md-11 pe-0" style={{ width: '95.6%' }}>
                                            <Button
                                                className="p-button text-center w-100 borderRadius"
                                                style={{ backgroundColor: `${form.metricHeaderColor}` }}
                                                label={`Dispute - ${index + 1}`}
                                            />
                                            <div className="row pt-3" key={index}>
                                                <div className="col-md-6 pt-1">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <h6>Metric</h6>
                                                            <InputText
                                                                name="metricLabels"
                                                                value={form.metricLabel}
                                                                onChange={(event) =>
                                                                    handleFormChange(event, index)
                                                                }
                                                                className="borderRadius"
                                                                readOnly
                                                            />
                                                            <h6 className="mt-3 pt-2">Dispute Reason</h6>
                                                            <Dropdown
                                                                name="disputeReasonid"
                                                                value={form.disputeReasonid}
                                                                options={disputeReasonData?.data}
                                                                onChange={(event) =>
                                                                    handleFormChange(event, index)
                                                                }
                                                                optionValue={'reason_id'}
                                                                optionLabel={'reason_name'}
                                                                placeholder="Select Reason"
                                                                className="borderRadius"
                                                                disabled
                                                            />
                                                            {form.resolutionClicked === true ? (
                                                                <div>
                                                                    <h6 className="mt-3 pt-2">
                                                                        Resolution Reason
                                                                    </h6>
                                                                    <Dropdown
                                                                        value={form.resolutionReasonId}
                                                                        name="resolutionReasonId"
                                                                        options={resolutionReasons?.data}
                                                                        onChange={(event) =>
                                                                            handleFormChange(event, index)
                                                                        }
                                                                        optionLabel="reason_name"
                                                                        optionValue="reason_id"
                                                                        placeholder="Select Reason"
                                                                        className="borderRadius"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div />
                                                            )}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <h6>Disputed Value</h6>
                                                            <InputText
                                                                name="disputedValue"
                                                                value={form.disputedValue}
                                                                onChange={(event) =>
                                                                    handleFormChange(event, index)
                                                                }
                                                                className="borderRadius"
                                                                readOnly
                                                            />

                                                            <h6 className="mt-3 pt-2">Expected Value</h6>
                                                            <InputText
                                                                name="proposedValue"
                                                                value={form.proposedValue}
                                                                onChange={(event) =>
                                                                    handleFormChange(event, index)
                                                                }
                                                                className="borderRadius"
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <h6>Associate Comment</h6>
                                                    <InputTextarea
                                                        name="disputeComment"
                                                        readOnly
                                                        value={form.disputeComment}
                                                        onChange={(event) => handleFormChange(event, index)}
                                                        rows={5}
                                                        cols={30}
                                                        className="borderRadius"
                                                        autoResize={false}
                                                        maxLength={4000}
                                                    />
                                                    <div className="row disputeCommentFooterText">
                                                        <div className="col-md-6">
                                                            {form.disputeDate.toLocaleString('en-US', {
                                                                dateStyle: 'medium',
                                                            })}
                                                        </div>
                                                        <div className="col-md-6 text-end">
                                                            Added by {form.disputeCreateBy}
                                                        </div>
                                                    </div>
                                                    {form.resolutionClicked === true ? (
                                                        <div>
                                                            <DescriptionBox
                                                                title="Resolution Comment"
                                                                value={form.resolutionComment}
                                                                responseDescription={form.resolutionComment}
                                                                onChange={(value) => {
                                                                    const syntheticEvent = {
                                                                        target: {
                                                                            name: 'resolutionComment',
                                                                            value,
                                                                        },
                                                                    };
                                                                    handleFormChange(syntheticEvent, index);
                                                                }}
                                                                limit={4000}
                                                            />
                                                            <div className="row disputeCommentFooterText">
                                                                <div className="col-md-6">
                                                                    {new Date().toLocaleString('en-US', {
                                                                        dateStyle: 'medium',
                                                                    })}
                                                                </div>
                                                                <div className="col-md-6 text-end">
                                                                    Added by {loggedUser}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div />
                                                    )}
                                                    {form.resolutionClicked === false ? (
                                                        <Button
                                                            type="button"
                                                            className="btn-export"
                                                            icon="pi pi-check-circle"
                                                            label="Resolve Dispute"
                                                            style={{ width: '215px', float: 'right' }}
                                                            onClick={() => {
                                                                ResolveDisputeClick(index);
                                                            }}
                                                        />
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                );
                            })
                        ) : (
                            <>
                                <Divider className="m-0 pb-4" />
                                <div className="col-md-11 pe-0" style={{ width: '95.6%' }}>
                                    <Button
                                        className="p-button text-center w-100 borderRadius"
                                        label="Disputes"
                                    />
                                    <div className="row pt-3">
                                        <div className="col-md-6 pt-1">
                                            <div className="row">
                                                <div className="col-md-10">
                                                    <h6 className="mt-3 pt-2">Resolution Reason</h6>
                                                    <Dropdown
                                                        value={inputResolutionReasonId}
                                                        name="resolutionReasonId"
                                                        options={resolutionReasons?.data}
                                                        onChange={(event) => handleResolveFormChange(event)}
                                                        optionLabel="reason_name"
                                                        optionValue="reason_id"
                                                        placeholder="Select Reason"
                                                        className="borderRadius"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <DescriptionBox
                                                title="Resolution Comment"
                                                value={inputResolutionComment}
                                                responseDescription={inputResolutionComment}
                                                onChange={(value) => {
                                                    const syntheticEvent = {
                                                        target: {
                                                            name: 'resolutionComment',
                                                            value,
                                                        },
                                                    };
                                                    handleResolveFormChange(syntheticEvent);
                                                }}
                                                limit={4000}
                                            />
                                            <div className="row disputeCommentFooterText">
                                                <div className="col-md-6">
                                                    {new Date().toLocaleString('en-US', {
                                                        dateStyle: 'medium',
                                                    })}
                                                </div>
                                                <div className="col-md-6 text-end">Added by {loggedUser}</div>
                                            </div>
                                            <div className="row disputeCommentFooterText">
                                                <div className="col-md-12">
                                                    *Comments appended to all selected disputes.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ) : (
                    <div>
                        <Divider className="m-0 pb-4" />
                        {saveSuccessMessage}
                    </div>
                )}
            </Dialog>
        </div>
    );
};
